import { render, staticRenderFns } from "./NotificationBox.vue?vue&type=template&id=72d4da8f&scoped=true&"
import script from "./NotificationBox.vue?vue&type=script&lang=js&"
export * from "./NotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBox.vue?vue&type=style&index=0&id=72d4da8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d4da8f",
  null
  
)

export default component.exports